import React, { forwardRef } from 'react';
import { View } from 'react-native';
import MultiFeatureCard from '../../../../components/Common/Card/MultiOptionsCard/MultiFeatureCard';
import AlertSummaryTable from './AlertSummaryTable';
import AlertsSummaryGraph from './AlertSummaryGraph';
import get from 'lodash/get';
import { Icons } from '@hmsexp/component-library';

const AlertSummary = ({
  alerts_data,
  applied_filter_values,
  applied_filters,
  columns,
  sortConfig,
  handleOnSortClick,
  sortingInProgress,
  alerts_config
}) => {
  const timeperiodLabel = get(applied_filters, 'timePeriod[0].fullLabel', ' ');
  const actionItems=alerts_config?.contents?.action_items

  const actionMenu = [
    {
        title: 'Export',
        icon: <Icons.UploadIcon />,
        items: actionItems
    }
  ];

  return (
      <View style={{ marginTop: 20 }}>
        <MultiFeatureCard
          title={alerts_config?.contents?.title || 'Alerts Summary'}
          subTitle={timeperiodLabel}
          enableActionBtn={true}
          enableSwitchTab={true}
          switchOptions={alerts_config?.contents?.switchOptions || ['TABLE', 'BAR']}
          actionMenu={actionMenu}
          renderContent={(activeSwitch, ref) =>
            activeSwitch === 'TABLE' ? (
              <AlertSummaryTable
                data={alerts_data}
                applied_filter_values={applied_filter_values}
                columns={columns}
                sortConfig={sortConfig}
                handleOnSortClick={handleOnSortClick}
                sortingInProgress={sortingInProgress}
                alerts_config={alerts_config}
              />
            ) : (
              <AlertsSummaryGraph data={alerts_data} ref={ref} />
            )
          }
        />
      </View>
    );
  }

export default AlertSummary;